import { useContext, useState } from "react";
import { CheckCircle } from "lucide-react";
import "../../../styles/pages-styles/main-dashboard-pages-styles/user-sidebar-pages/CancelPage.css";
import { cancelSubscription } from "../../../services/paymentService";
import { UserContext } from "../../../contexts/UserContext";

export default function CancellationFlow() {
  const { userProfile, accessToken } = useContext(UserContext);
  let userEmail = sessionStorage.getItem("userEmail")
  const [step, setStep] = useState(1);
  const [reason, setReason] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);


  const handleCancel = () => {
    // setStep(2);
    cancelSubscription(userEmail, accessToken)
  };

  const handleBack = () => {
    setStep(1);
  };

  const handleReasonSelect = (selectedReason) => {
    setReason(selectedReason);
  };

  const handleSubmit = () => {
    if (reason) {
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setStep(3);
  };

  return (
    <div className="cancellation-page-container">
      {step === 1 && (
        <div className="cancellation-page-card">
          <h2 className="cancellation-page-title">
            Are you sure you want to cancel?
          </h2>
          <p className="cancellation-page-description">
            You will lose many amazing, wonderful features!
          </p>
          <div className="cancellation-page-buttons">
            <button
              className="cancellation-page-confirm-button"
              onClick={handleCancel}
            >
              Yes, cancel
            </button>
            <button
              className="cancellation-page-back-button"
              onClick={handleBack}
            >
              No, go back
            </button>
          </div>
        </div>
      )}

      {/* {step === 2 && (
        <div className="cancellation-page-card">
          <h2 className="cancellation-page-title">Why are you canceling?</h2>
          <div className="cancellation-page-reason-options">
            <div className="cancellation-page-reason-option">
              <input
                type="radio"
                id="expensive"
                name="reason"
                className="cancellation-page-reason-radio"
                onChange={() => handleReasonSelect("It's too expensive")}
              />
              <label
                className="cancellation-page-reason-label"
                htmlFor="expensive"
              >
                It's too expensive
              </label>
            </div>
            <div className="cancellation-page-reason-option">
              <input
                type="radio"
                id="dontuse"
                name="reason"
                className="cancellation-page-reason-radio"
                onChange={() => handleReasonSelect("I don't use this anymore")}
              />
              <label
                className="cancellation-page-reason-label"
                htmlFor="dontuse"
              >
                I don't use this anymore
              </label>
            </div>
            <div className="cancellation-page-reason-option">
              <input
                type="radio"
                id="switching"
                name="reason"
                className="cancellation-page-reason-radio"
                onChange={() =>
                  handleReasonSelect("I'm switching to another product")
                }
              />
              <label
                className="cancellation-page-reason-label"
                htmlFor="switching"
              >
                I'm switching to another product
              </label>
            </div>
            <div className="cancellation-page-reason-option">
              <input
                type="radio"
                id="other"
                name="reason"
                className="cancellation-page-reason-radio"
                onChange={() => handleReasonSelect("I have written my exams")}
              />
              <label className="cancellation-page-reason-label" htmlFor="other">
                I have written my exams
              </label>
            </div>
          </div>
          <button
            className={`cancellation-page-submit-button ${
              reason ? "active" : "disabled"
            }`}
            onClick={handleSubmit}
            disabled={!reason}
          >
            Submit
          </button>
        </div>
      )} */}

      {step === 3 && (
        <div className="cancellation-page-card">
          <div className="cancellation-page-success-container">
            <div className="cancellation-page-icon-wrapper">
              <CheckCircle color="#DB2777" size={32} />
            </div>
            <h2 className="cancellation-page-title">
              Your subscription has been canceled
            </h2>
            <p className="cancellation-page-success-message">
              You can always come back and re-subscribe. Your plan is active
              until the end of your billing cycle.
            </p>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="cancellation-page-modal">
          <div className="cancellation-page-modal-content">
            <div className="cancellation-page-success-container">
              <div className="cancellation-page-icon-wrapper">
                <CheckCircle color="#DB2777" size={32} />
              </div>
              <h2 className="cancellation-page-title">
                Your subscription has been canceled
              </h2>
              <p className="cancellation-page-success-message">
                You can always come back and re-subscribe. Your plan is active
                until the end of your billing cycle.
              </p>
              <button
                className="cancellation-page-modal-close"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
